import GlobalEvents from "base/GlobalEvents";
import PromiseHelper from "base/PromiseHelper";
import $ from "jquery";

export default class PageAnimations {
    static start() {
        PageAnimations.stop();

        if (PageAnimations.reduced_motion()) {
            PageAnimations.clear_all();
            return;
        }

        PageAnimations.check();
        $("body").addClass("has-js");
        $(window).on("scroll resize", PageAnimations.check);
    }

    static stop() {
        $(window).off("scroll resize", PageAnimations.check);
    }

    static check() {
        let windowHeight = $(window).outerHeight();
        let scrollBottom = $(window).scrollTop() + windowHeight;
        let documentHeight = $(document).height();

        $(".a:not(.a--play)").each(function () {
            let $this = $(this);
            let threshold = $this.is("[data-threshold]") ? parseInt($this.attr("data-threshold")) : 15;

            let top = $(this).offset().top;
            if ((top + (threshold * windowHeight) / 100 < scrollBottom) || scrollBottom === documentHeight) {
                $this.addClass("a--play").trigger("animation-start");

                if (!$this.is("[data-keep-classes]")) {
                    if ($this.is("[data-timeout]")) {
                        let defaultTimeout = $this.is("[data-timeout]") ? parseInt($this.attr("data-timeout")) : 1000;

                        setTimeout(() => PageAnimations.remove_classes($this), defaultTimeout);
                    } else {
                        let promises = $this.find(".a__i").map(function () {
                            let $item = $(this);
                            let delay = 0;
                            let duration = 0;

                            PageAnimations.get_classes($item).forEach((clazz) => {
                                let delayMatch = PageAnimations.DELAY_REGEX.exec(clazz);
                                if (delayMatch !== null) {
                                    delay = parseInt(delayMatch[1]);
                                    return;
                                }
                                let durationMatch = PageAnimations.DURATION_REGEX.exec(clazz);
                                if (durationMatch !== null) {
                                    duration = parseInt(durationMatch[1]);
                                }
                            });

                            return PromiseHelper.timed_promise(delay + duration + 150).then(() => PageAnimations.clean_up_element($item));
                        }).get();

                        Promise.all(promises).then(() => PageAnimations.remove_classes($this));
                    }
                }
            }
        });
    }

    static remove_classes($item) {
        $item.find(".a__i").add($item).each(function () {
            PageAnimations.clean_up_element($(this));
        });
        $item.trigger("animationDone");
    }

    static clean_up_element($element) {
        $element.trigger("animationItemDone");

        if (!$element.attr("class") || $element.is("[data-keep-classes]")) return;

        $.each(PageAnimations.get_classes($element), function (_, clazz) {
            if (PageAnimations.CLASSES_REGEX.test(clazz)) {
                $element.removeClass(clazz);
            }
        });
    }

    static get_classes($item) {
        return $item.attr("class").split(/\s+/);
    }

    static clear_all() {
        PageAnimations.remove_classes($(".a:not([data-keep-classes])"));
    }

    static reduced_motion() {
        try {
            return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        } catch (e) {
            console.warn("Couldn't check for reduced motion", e);
            return false;
        }
    }
}

GlobalEvents.on("PageAnimations.clear_all page.beginEditing", () => PageAnimations.clear_all());

PageAnimations.CLASSES_REGEX = /^(a|a__.+)$/;
PageAnimations.DURATION_REGEX = /^a__i--dur-([0-9]+)$/;
PageAnimations.DELAY_REGEX = /^a__i--delay-([0-9]+)$/;
